<template>
  <div class="mb-8">
    <v-card flat
            tile>
      <v-card-title>
        {{ name }}
      </v-card-title>
      <v-divider></v-divider>
      <v-row v-if="results.length"
             class="px-3">
        <v-col v-for="result in results"
               :key="result.id"
               class="d-flex child-flex"
               cols="12"
               sm="3">
          <email-preview-thumbnail-card :result="result"
                                        @update="$emit('update')">
          </email-preview-thumbnail-card>
        </v-col>
      </v-row>
      <v-card-text v-else>
        No tests.
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import EmailPreviewThumbnailCard from './EmailPreviewThumbnailCard.vue';

export default {
  components: {EmailPreviewThumbnailCard},
  props: {
    name: {
      type: String,
      required: true,
    },
    results: {
      type: Array,
      required: true,
    },
  }
}
</script>
